<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="ibox-title">
        <h5>Build Report</h5>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Report/Filters'
import List from './Report/List'
export default {
  data () {
    return {
      name: 'Report'
    }
  },
  components: {
    filters: Filters,
    list: List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/Report.vue